module.exports = __webpack_public_path__ + "img/HappyPhoto13.3be10ab0.jpeg";